(() => {
  const pad = (n) => String(Math.max(0, n)).padStart(2, '0');

  function getLondonParts(date) {
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/London',
      year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit',
      hourCycle: 'h23'
    }).formatToParts(date);
    return Object.fromEntries(parts.map((p) => [p.type, p.value]));
  }

  function londonMidnightTarget(now) {
    const p = getLondonParts(now);
    const londonDate = `${p.year}-${p.month}-${p.day}`;

    // Find the UTC instant corresponding to the next 00:00 in Europe/London.
    const middayUtc = new Date(`${londonDate}T12:00:00Z`);
    const nextDay = new Date(middayUtc.getTime() + 24 * 60 * 60 * 1000);
    const next = getLondonParts(nextDay);
    const targetDate = `${next.year}-${next.month}-${next.day}`;

    let guess = new Date(`${targetDate}T00:00:00Z`);
    for (let i = 0; i < 3; i++) {
      const gp = getLondonParts(guess);
      const represented = Date.UTC(+gp.year, +gp.month - 1, +gp.day, +gp.hour, +gp.minute, +gp.second);
      const wanted = Date.UTC(+next.year, +next.month - 1, +next.day, 0, 0, 0);
      guess = new Date(guess.getTime() + (wanted - represented));
    }
    return guess.getTime();
  }

  function updateTimer(el) {
    const now = Date.now();
    const target = londonMidnightTarget(new Date(now));
    const remaining = Math.max(0, target - now);
    const totalSeconds = Math.ceil(remaining / 1000);
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    const h = el.querySelector('[data-countdown-hrs]');
    const m = el.querySelector('[data-countdown-min]');
    const s = el.querySelector('[data-countdown-sec]');

    if (h) h.textContent = pad(hours);
    if (m) m.textContent = pad(minutes);
    if (s) s.textContent = pad(seconds);
  }

  function tick() {
    document.querySelectorAll('[data-autumn-countdown]').forEach(updateTimer);
  }

  tick();
  setInterval(tick, 250);
})();
